/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ delta: NonNullable<unknown> }} Workout_After_Delta_LineInputs */

const en_us2_workout_after_delta_line = /** @type {(inputs: Workout_After_Delta_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.delta} than today's plan, by your choice`)
};

const pt_br2_workout_after_delta_line = /** @type {(inputs: Workout_After_Delta_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.delta} que o plano de hoje, por escolha sua`)
};

const es_419_workout_after_delta_line = /** @type {(inputs: Workout_After_Delta_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.delta} que el plan de hoy, por elección tuya`)
};

const pt_pt2_workout_after_delta_line = /** @type {(inputs: Workout_After_Delta_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.delta} do que o plano de hoje, por escolha tua`)
};

const fr_fr2_workout_after_delta_line = /** @type {(inputs: Workout_After_Delta_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.delta} que le programme du jour, par ton choix`)
};

const de_de2_workout_after_delta_line = /** @type {(inputs: Workout_After_Delta_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.delta} als im heutigen Plan, auf deinen Wunsch`)
};

const it_it2_workout_after_delta_line = /** @type {(inputs: Workout_After_Delta_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.delta} rispetto alla scheda di oggi, per tua scelta`)
};

/**
* | output |
* | --- |
* | "{delta} than today's plan, by your choice" |
*
* @param {Workout_After_Delta_LineInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_delta_line = /** @type {((inputs: Workout_After_Delta_LineInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_Delta_LineInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_delta_line(inputs)
	if (locale === "es-419") return es_419_workout_after_delta_line(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_delta_line(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_delta_line(inputs)
	if (locale === "de-DE") return de_de2_workout_after_delta_line(inputs)
	if (locale === "it-IT") return it_it2_workout_after_delta_line(inputs)
	return en_us2_workout_after_delta_line(inputs)
});
export { workout_after_delta_line as "workout-after.delta_line" }